import factoryLogger from '../../logger/index.js'
import SmartbannerRepositoriesFactory from '../Repositories/factory.js'
import GetSmartbannerUseCase from './GetSmartbannerUseCase.js'
import SetSmartbannerUseCase from './SetSmartbannerUseCase.js'

export default class SmartbannerUsecasesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetSmartbannerUseCase}
   * @property {Config} Config
   * @property {Function} log
   */
  static getSmartbannerUseCase = ({config}) =>
    new GetSmartbannerUseCase({
      repository: SmartbannerRepositoriesFactory.CookieSmartbannerRepository({
        config
      }),
      log: factoryLogger({prefix: 'GetSmartbannerUseCase'})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {SetSmartbannerUseCase}
   * @property {Config} Config
   * @property {Function} log
   */
  static setSmartbannerUseCase = ({config}) => {
    return new SetSmartbannerUseCase({
      repository:
        typeof localStorage !== 'undefined'
          ? SmartbannerRepositoriesFactory.CookieSmartbannerRepository({
              config
            })
          : SmartbannerRepositoriesFactory.emptyCookieSmartbannerRepository({
              config
            }),
      log: factoryLogger({prefix: 'SetSmartbannerUseCase'})
    })
  }
}
